import type { QuickStartSectionRef } from '../github.interface'
import { pickDefaultQuickStartLanguage } from '../utils/pickDefaultQuickStartLanguage'

import { resolveLanguageList } from './utils/resolveLanguageList'
import { stripNumericPathPrefix } from './utils/stripNumericPathPrefix'

/**
 * Path string relative to `/quick-start` for navigation, keeping `preferredLanguage` when available.
 * Numeric order prefixes are stripped from each segment (e.g. "2-expose-backend" → "expose-backend").
 */
export function quickStartNavUrlPathForSection(target: QuickStartSectionRef, preferredLanguage?: string): string {
  const langs = resolveLanguageList(target)
  const lang =
    preferredLanguage && langs.includes(preferredLanguage)
      ? preferredLanguage
      : (target.defaultLanguage ?? pickDefaultQuickStartLanguage(langs))
  const pathParts = stripNumericPathPrefix(target.path).split('/').filter(Boolean)
  if (langs.length === 1) return pathParts.join('/')
  return `${pathParts.join('/')}/${lang}`
}
